import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { sendGTMEvent } from 'reduxModules/googleTagManager/action';
import { COURSE_TIMESTAMP_CHAPTER_CLICK } from 'constants/gtmEvent';
import usePrevious from 'hooks/usePrevious';

const useChapterOpenEventTrack = ({ isOpen, lessonEventTrackData }) => {
  const dispatch = useDispatch();
  const {
    lessonIndex,
    timestampNum,
    ...commonLessonGtmData
  } = lessonEventTrackData;
  const prevIsOpen = usePrevious(isOpen);

  useEffect(() => {
    if (!(!!prevIsOpen === false && isOpen && lessonIndex !== undefined)) {
      return;
    }

    dispatch(
      sendGTMEvent({
        eventName: COURSE_TIMESTAMP_CHAPTER_CLICK,
        data: {
          ...commonLessonGtmData,
          timestampNum,
          itemIndex: lessonIndex,
        },
      }),
    );
  }, []);

  return commonLessonGtmData;
};

export default useChapterOpenEventTrack;
